"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RUM = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context5, _context6; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty2(_context5 = ownKeys(Object(t), !0)).call(_context5, function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty2(_context6 = ownKeys(Object(t))).call(_context6, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
// Based on eax implementation: https://gitlab-app.eng.qops.net/eax/admin/-/blob/master/portal/client/rum.tsx
var RUMSingleton = /*#__PURE__*/function () {
  function RUMSingleton() {
    (0, _classCallCheck2.default)(this, RUMSingleton);
    (0, _defineProperty2.default)(this, "times", {});
  }
  return (0, _createClass2.default)(RUMSingleton, [{
    key: "setMetricTime",
    value: function setMetricTime(rumId, metric) {
      if (!this.times[rumId]) this.times[rumId] = {};
      this.times[rumId][metric] = new Date().getTime();
    }
  }, {
    key: "post",
    value: function post(rumId, meta) {
      var _context,
        _this = this,
        _context2;
      var useRequestStartAsBaseline = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // PerformanceTiming is deprecated and PerformanceNavigationTiming should be used in the new solutions.
      // However it's supported neither on IE nor Safari so we should stick to this approach for now.
      if (!(window.performance && window.performance.timing)) {
        return;
      }
      var t = window.performance.timing;
      if (!this.times[rumId]) {
        this.times[rumId] = {};
      }
      var baselineForAppMetrics = useRequestStartAsBaseline ? t.requestStart : t.navigationStart;
      var initTimings = {};
      (0, _forEach.default)(_context = (0, _keys.default)(this.times[rumId])).call(_context, function (metric) {
        initTimings[metric] = _this.times[rumId][metric] - baselineForAppMetrics;
      });
      var timings = _objectSpread(_objectSpread({}, initTimings), {}, {
        id: rumId,
        meta: meta,
        url: window.location.href,
        userAgent: window.navigator.userAgent,
        connect: t.connectEnd - t.connectStart,
        dns: t.domainLookupEnd - t.domainLookupStart,
        redirect: t.redirectEnd - t.redirectStart,
        requestStart: t.requestStart - t.navigationStart,
        responseStart: t.responseStart - t.navigationStart,
        responseEnd: t.responseEnd - t.navigationStart,
        responseTotal: t.responseEnd - t.responseStart,
        domLoading: t.domLoading - t.navigationStart,
        domInteractive: t.domInteractive - t.navigationStart,
        domContentLoaded: t.domContentLoadedEventEnd - t.navigationStart,
        domComplete: t.domComplete - t.navigationStart,
        domTotal: t.domComplete - t.domLoading,
        appTotal: this.times[rumId].appComplete - this.times[rumId].appLoading
      });
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/rum/global', true);
      xhr.send((0, _concat.default)(_context2 = "".concat(new Date().toISOString(), " [rum] ")).call(_context2, (0, _stringify.default)(timings)));
    }
  }, {
    key: "postComponentTimings",
    value: function postComponentTimings(rumId, baseline, meta) {
      var _context3,
        _this2 = this,
        _context4;
      if (!this.times[rumId]) {
        this.times[rumId] = {};
      }
      var initTimings = {};
      (0, _forEach.default)(_context3 = (0, _keys.default)(this.times[rumId])).call(_context3, function (metric) {
        initTimings[metric] = _this2.times[rumId][metric] - baseline;
      });
      var timings = _objectSpread(_objectSpread({}, initTimings), {}, {
        id: rumId,
        meta: meta,
        url: window.location.href,
        userAgent: window.navigator.userAgent,
        appTotal: this.times[rumId].appComplete - this.times[rumId].appLoading
      });
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/rum/global', true);
      xhr.send((0, _concat.default)(_context4 = "".concat(new Date().toISOString(), " [rum] ")).call(_context4, (0, _stringify.default)(timings)));
    }
  }]);
}();
var RUM = exports.RUM = new RUMSingleton();
//# sourceMappingURL=rumLogger.js.map